import {GET_FCM_DEVICES_START} from "../../types";

export const fcm_devices = (payload) => ({
  type: GET_FCM_DEVICES_START,
  payload,
});
